export default {
  common: { close: 'Close' },
  login: {
    welcomeBack: 'Welcome back', signInContinue: 'Sign in to sync your saved places', email: 'Email',
    emailPlaceholder: 'you@example.com', password: 'Password', passwordPlaceholder: '••••••••',
    signIn: 'Sign in', signingIn: 'Signing in…', newHere: 'New here?', createAccount: 'Create account',
    loginFailed: 'Sign in failed', loginError: 'Something went wrong while signing in'
  },
  register: {
    createAccountTitle: 'Create account', startDiscovering: 'An account is only needed to sync saved places',
    name: 'Name', namePlaceholder: 'Your name', confirmPassword: 'Confirm password',
    confirmPasswordPlaceholder: 'Enter your password again', minCharacters: 'At least 6 characters',
    createAccountBtn: 'Create account', creatingAccount: 'Creating account…', alreadyHaveAccount: 'Already have an account?',
    signInLink: 'Sign in', passwordsNotMatch: 'Passwords do not match',
    registrationFailed: 'Registration failed', registrationError: 'Something went wrong while registering'
  }
};
